import { Modal } from "antd"
import React, { useEffect, useState } from "react"
import { initializeHubspotForm } from "../../utils/gatsby-helpers"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

// The state is the object of modal state
// The form is the hubspot data
export const ModalPricing = ({ state, form }) => {
    const closeModalForm = () => {
        state.closeMenu()
    }

    const title = (
        (form.title || form.description) &&
        <>
            {form.title &&
                <h4>{form.title}</h4>
            }
            {form.description &&
                <ReactMarkdown
                    children={form.description}
                    rehypePlugins={[rehypeRaw]}
                />
            }
        </>
    )

    return (
        <Modal
            centered
            footer={null}
            maskClosable={false}
            onCancel={closeModalForm}
            title={title}
            visible={state.isOpen}
            width={"100%"}
            wrapClassName="main__section"
            destroyOnClose={true}
        >
            <div className="modal-pricing__container">
                {form.pricing_option.map(option => {
                    return (
                        <div  className="modal-pricing__container__card">
                            <div className="card__header">
                                <span  className="card__header__quantity">{option.quantity}</span>
                                <span  className="card__header__price">{option.price}</span>
                            </div>
                            <span>{option.detail}</span>
                        </div>
                    )
                })}
            </div>
        </Modal>
    )
}

// The modal state to manage if its open or closed and its functions
export const ModalState = () => {
    const [isOpen, setIsOpen] = useState(false)

    const openMenu = () => setIsOpen(true)
    const closeMenu = () => setIsOpen(false)
    const toggleMenu = () => setIsOpen(!isOpen)

    return { isOpen, openMenu, closeMenu, toggleMenu }
}
